// 별점을 ★ 5칸으로 바꾼다. 목록·상세가 함께 쓴다.
// 서버 값이 0~5 밖이거나 숫자가 아니어도 repeat 오류로 화면이 깨지지 않게 범위를 자른다.
export function toStars(rating) {
    const score = Math.min(5, Math.max(0, Math.round(Number(rating)) || 0));
    return '★'.repeat(score) + '☆'.repeat(5 - score);
}
